import FilterSetHandler from "@/ts/components/FilterSetHandler";
import EtRangeSlider from "@/ts/components/EtRangeSlider";

export default function(vwtype: string, vwname: string): void {
    const currentItem = document.querySelector('.layout_header__dnav_item.current .layout_header__dnav_button');
    const sidebarTitle = document.querySelector('.element_sidebar_navigation_h1');
    if (currentItem && sidebarTitle) {
        const backgroundColor = window.getComputedStyle(currentItem).backgroundColor;
        const color = backgroundColor === "rgba(0, 0, 0, 0)" ? "var(--color-primary)" : backgroundColor;
        ['color', 'hover', 'focus', 'active'].forEach(style => sidebarTitle.style[style] = color);
    }

    new EtRangeSlider();
    new FilterSetHandler();
}